import {
  DeliveryConfigurationUi,
  WeekDayDeliveryUi,
} from '@/components/Seller/SellerProfile/SalesAndDelivery/DeliveryConfiguration/DeliveryConfigurationUi';
import {
  DayDeliveryScheduleRequest,
  UpdateSellerDeliveryDetailsRequest,
  UpdateSellerDeliverySchedulesRequest,
} from '@/data/api/model/sellers/SellersDto';

export function deliveryConfigurationUiToUpdateSellerDeliveryDetailsRequest(
  uiState: DeliveryConfigurationUi
): UpdateSellerDeliveryDetailsRequest {
  return {
    next_day_delivery_time_cutoff:
      uiState.nextDayCutOffTime?.format('HH:mm') ?? '',
    next_available_delivery_time: uiState.timePeriodSelected,
  };
}

export function deliveryConfigurationUiToUpdateSellerDeliverySchedulesRequest(
  uiState: DeliveryConfigurationUi
): UpdateSellerDeliverySchedulesRequest {
  return uiState.deliveryDays.map((deliveryDayUi) =>
    weekDayDeliveryUiToDayDeliveryScheduleRequest(deliveryDayUi)
  );
}

function weekDayDeliveryUiToDayDeliveryScheduleRequest(
  input: WeekDayDeliveryUi
): DayDeliveryScheduleRequest {
  const ret: DayDeliveryScheduleRequest = {
    delivery_day_id: input.dayId,
    start_time: input.enabled
      ? input?.minDeliveryTime?.format('HH:mm')
      : undefined,
    end_time: input.enabled
      ? input?.maxDeliveryTime?.format('HH:mm')
      : undefined,
    is_active: input?.enabled ?? false,
  };
  return ret;
}
